<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-alert type="error" :value="true" v-if="quotePermitStatus.permitStatus === 'D'">
      Quotation Declined
      <ul class="permitStatus">
        <li v-for="status in quotePermitStatus.declineList" :key="status">{{status}}</li>
      </ul>
    </v-alert>
    <v-alert type="warning" :value="true" v-else-if="quotePermitStatus.permitStatus === 'R'">
      Quotation Referred
      <ul class="permitStatus">
        <li v-for="status in quotePermitStatus.referredList" :key="status">{{status}}</li>
      </ul>
    </v-alert>
    <message :messages="messages"></message>
    <premium-shared v-if="showPremiumSummary"></premium-shared>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>

      <v-btn color="secondary" dark type="submit" :loading="quotation.saving" @click.prevent="doProceedProposal" :disabled="premiumInfo.init !== 1" v-if="quotePermitStatus.permitStatus == 'A' ||  ( quotePermitStatus.permitStatus == 'R' && checkAccess(['motorQuoteRef', 'motorQuoteSTP']) )">
        Proceed to Proposal
        <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
      </v-btn>
      <v-btn color="primary" type="submit" :loading="quotation.saving" @click.prevent="doSendForRef" v-if="quotePermitStatus.permitStatus === 'R'">
        Send for Review
        <v-icon right dark>mdi-account-check</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AGENCY_QUOTATION_LIFECYCLE, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { generalMotorForm } from '@/store/modules/agency/actions/quote'
import PremiumShared from './sub/PremiumShared'

export default {
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    premiumInfo() {
      return this.quotation.commonInfo.premium
    },
    quotePermitStatus() {
      return this.$store.getters.mtrQuotePermitStatus
    },
    showPremiumSummary() {
      if (this.quotePermitStatus.permitStatus === 'A') {
        return true
      } else if (this.quotePermitStatus.permitStatus === 'R') {
        // Only allow if user has permit acccess
        if (this.checkAccess(['motorQuoteRef', 'motorQuoteSTP'])) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
      this.$router.push({ name: 'motorQuoteStatistics' })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    async doSendForRef() {
      const apiUrl = this.quotation.menu.refQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalMotorForm(this.$store.state.agency))
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been submitted for review')
          // After success push to listing page
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$router.push({ name: 'motorQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          this.promptFieldCheck()
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doProceedProposal() {
      const apiUrl = this.quotation.menu.proceedQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalMotorForm(this.$store.state.agency))

          // After success push to proposal page
          const dispatchObj = {
            proposalNo: result.data.proposalNo,
            query: false
          }
          await this.$store.dispatch('loadQuote', dispatchObj)
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has converted to Proposal')
          this.$router.push({ name: 'motorProposal' })
        } catch (err) {
          this.promptFieldCheck()
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 5) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 5)
    }
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  components: {
    PremiumShared
  }
}
</script>

<style lang="scss">
</style>
